import request from "@utils/request";
import { ParamsProps, ReturnType } from "./types";

const create = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `types`,
      method: "post",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Created Successfully",
        showErr: true,
        store: {
          key: args?.state,
          action: "prepend",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const update = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `types/${args?.id}`,
      method: "patch",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Update Successfully",
        showErr: true,
        store: {
          key: args?.state,
          action: "update",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const remove = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `types/${args?.id}`,
      method: "delete",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Deleted Successfully",
        showErr: true,
        store: {
          key: args?.state,
          action: "remove",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: "types",
      method: "get",
      authorization: true,
      params: args?.params,
      config: {
        showErr: true,
      },
    };
    if (args.state) {
      config.config.store = {
        key: args?.state,
        action: "set",
      };
    }
    const response = await request(config);

    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const find = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `types/${args.id}`,
      method: "get",
      authorization: true,
      params: args?.params,
      config: {
        showErr: true,
      },
    };
    if (args.state) {
      config.config.store = {
        key: args?.state,
        action: "set",
      };
    }
    const response = await request(config);

    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const addPopular = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `types/${args?.id}/popular`,
      method: "post",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Added to Popular Successfully",
        showErr: true,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const addFeatured = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `types/${args?.id}/featured`,
      method: "post",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Added to Featured Successfully",
        showErr: true,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const addRecommended = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `types/${args?.id}/recommended`,
      method: "post",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Added to Recommended Successfully",
        showErr: true,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const getPopularStores = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `types/${args?.id}/popular`,
      method: "get",
      authorization: true,
      config: {
        showErr: true,
        store: {
          action: "set",
          key: args?.state,
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const getFeaturedStores = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `types/${args?.id}/featured`,
      method: "get",
      authorization: true,
      config: {
        showErr: true,
        store: {
          action: "set",
          key: args?.state,
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const getRecommendedStores = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `types/${args?.id}/recommended`,
      method: "get",
      authorization: true,
      config: {
        showErr: true,
        store: {
          action: "set",
          key: args?.state,
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const removeBanner = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `types/banner/${args?.id}`,
      method: "delete",
      authorization: true,
      config: {
        successMsg: "Banner Deleted Successfully",
        showErr: true,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

export default {
  list,
  create,
  update,
  remove,
  find,
  addPopular,
  addFeatured,
  addRecommended,
  getPopularStores,
  getFeaturedStores,
  getRecommendedStores,
  removeBanner,
};
